import React from 'react';
import PropTypes from 'prop-types';

import {
    FIELD_VALIDATION_ERROR_TYPES,
    MAX_COMMENT_LENGTH,
} from '../../../utils/constants'

import Caption from '../../Caption/Caption';
import EditLabelError from '../EditLabelError/EditLabelError';
import EditLabelText from '../EditLabelText/EditLabelText';
import Textarea from '../../Textarea/Textarea';

import {
    FIELD_MAX_LIMIT_EXCEED_ERROR,
} from '../../../translations'

import {
    EDIT_TO_MODERATOR_LABEL,
    EDIT_TO_MODERATOR_LABEL_TEXT,
    REVIEW_TO_MODERATOR_LABEL,
} from './translations'

import styles from './EditComment.module.css'

export default class EditComment extends React.PureComponent {
    static propTypes = {
        externalError: PropTypes.oneOf([
            FIELD_VALIDATION_ERROR_TYPES.MAX_LIMIT,
        ]),
        externalValue: PropTypes.string,
        isSecondary: PropTypes.bool,

        onValueChange: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.state = {
            errorType: null,
            value: '',
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.externalValue && nextProps.externalValue !== this.state.value) {
            this.setState({
                value: nextProps.externalValue,
            })
        }
    }

    handleValueChange = (value) => {
        let errorType = null

        if (value.length > MAX_COMMENT_LENGTH) {
            errorType = FIELD_VALIDATION_ERROR_TYPES.MAX_LIMIT
        }

        this.setState({ errorType, value })
        this.props.onValueChange(value, errorType)
    }

    renderError() {
        const errorToMessagesMapping = {
            [FIELD_VALIDATION_ERROR_TYPES.MAX_LIMIT]: FIELD_MAX_LIMIT_EXCEED_ERROR(MAX_COMMENT_LENGTH),
        }
        return this.state.errorType ? (
            <EditLabelError message={errorToMessagesMapping[this.state.errorType]} />
        ) : null
    }

    render() {
        return (
            <div className={styles.base}>
                <div className={styles.label}>
                    <Caption
                        isLarge={!this.props.isSecondary}
                        isError={!!this.props.externalError}
                    >
                        {window.location.pathname.includes('/review/') ? REVIEW_TO_MODERATOR_LABEL : EDIT_TO_MODERATOR_LABEL}
                    </Caption>
                    <EditLabelText message={EDIT_TO_MODERATOR_LABEL_TEXT} />
                    {this.renderError()}
                </div>
                <div className={styles.field}>
                    <Textarea
                        value={this.state.value}
                        isError={!!this.props.externalError}
                        onChange={this.handleValueChange}
                    />
                </div>
            </div>
        )
    }
}
